import { BookingSlot } from "@cur8/rich-entity";
import { DateTime } from "luxon";

export function filterUpcomingSlots(slots: BookingSlot[]) {
  return slots.filter((slot) => {
    return slot.endTime > DateTime.now();
  });
}
